import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { NotificationApi } from '../api/notification.api';
import { IQueryFilter, QueryResult } from '../model/query.filter.class';
import { apiCallWrapper } from '../api/api.util';
import { LoadingService } from './core/loading.service';

@Injectable({ providedIn: 'root' })
export class NotificationStateService {

  private _hasNewNotification$ = new BehaviorSubject<boolean>(false);
  hasNewNotification$ = this._hasNewNotification$.asObservable();

  constructor(private notificationApi: NotificationApi, private loadingService: LoadingService) { }

  loadNotifications(query: IQueryFilter, isShowLoader = false) {
    if (isShowLoader) return apiCallWrapper(this.loadingService.blockWithLoadingOverlayRx(this.notificationApi.list(query)));

    return apiCallWrapper(this.notificationApi.list(query));
  }

  addNotification() {
    this._hasNewNotification$.next(true);
  }

  clearNotificationFlag() {
    this._hasNewNotification$.next(false);
  }

  delete(id: string) {
    return apiCallWrapper(this.notificationApi.delete(id));
  }

  public update(data: { isRead: boolean, markAll: boolean, id?: string }) {
    return apiCallWrapper(this.notificationApi.markRead(data))
  }
}
